import * as Sentry from '@sentry/react';

export const setMonitoringContext = ({ userId, tenantId }) => {
  Sentry.setUser({ id: userId });
  Sentry.setTag('tenant.id', tenantId);
};
